import React from 'react';
import { Loader2 } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger' | 'danger-outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  loading?: boolean;
  icon?: React.ReactNode;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  loading = false,
  icon,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const {
    isLight
  } = useTheme();
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none rounded-xl active:scale-[0.98]';
  const variants = {
    primary: isLight ? 'bg-vexu hover:bg-vexu-600 text-white shadow-lg shadow-vexu/20 focus:ring-vexu focus:ring-offset-white' : 'bg-vexu hover:bg-vexu-400 text-black shadow-lg shadow-vexu/20 focus:ring-vexu focus:ring-offset-dark',
    secondary: isLight ? 'bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 hover:border-slate-300 focus:ring-slate-200 focus:ring-offset-white shadow-sm' : 'bg-white/5 backdrop-blur-lg border border-white/10 text-white hover:bg-white/10 focus:ring-white/20 focus:ring-offset-dark shadow-sm',
    ghost: isLight ? 'bg-transparent hover:bg-slate-100 text-slate-600 hover:text-slate-900 focus:ring-slate-200 focus:ring-offset-white' : 'bg-transparent hover:bg-white/5 hover:backdrop-blur-sm text-zinc-300 hover:text-white focus:ring-white/20 focus:ring-offset-dark',
    danger: isLight ? 'bg-red-500 hover:bg-red-600 text-white shadow-lg shadow-red-500/20 focus:ring-red-500 focus:ring-offset-white' : 'bg-red-500/90 hover:bg-red-500 text-white shadow-lg shadow-red-500/20 focus:ring-red-500 focus:ring-offset-dark',
    'danger-outline': isLight ? 'bg-white border border-red-200 text-red-600 hover:bg-red-50 focus:ring-red-500 focus:ring-offset-white' : 'bg-white/5 backdrop-blur-lg border border-red-500/30 text-red-400 hover:bg-red-500/10 focus:ring-red-500 focus:ring-offset-dark'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-11 px-4 text-base',
    lg: 'h-14 px-6 text-lg'
  };
  return <button className={`
        ${baseStyles}
        ${variants[variant]}
        ${sizes[size]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} disabled={disabled || loading} {...props} data-id="element-731" data-mp="235dnm81s4ln5">
      {loading ? <Loader2 className="w-5 h-5 animate-spin mr-2" data-id="element-732" data-mp="2h4msibkjbtbt" /> : icon ? <span className="mr-2" data-id="element-733" data-mp="2h2ag0dxjqb65">{icon}</span> : null}
      {children}
    </button>;
}